export const ADD_MENU_ENTRY_TO_CART = 'orderLine/ADD_MENU_ENTRY_TO_CART';
export const INC_ORDER_LINE_QUANTITY = 'orderLine/INC_ORDER_LINE_QUANTITY';
export const DEC_ORDER_LINE_QUANTITY = 'orderLine/DEC_ORDER_LINE_QUANTITY';
export const CHANGE_ORDER_LINE_MODIFIERS = 'orderLine/CHANGE_ORDER_LINE_MODIFIERS';
